import { collection, doc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { db } from "../../firebase/config";
import {
  AUTO_FILL_TERMS_VERSION,
  PROGRAM_WALLET_FIELD,
  PROGRAM_WALLET_VERIFIED_FIELD,
} from "../../config/autoFillLevelQualificationConfig";

async function userDocByUid(uid) {
  const snap = await getDocs(
    query(collection(db, "users"), where("uid", "==", uid))
  );
  if (snap.empty) return null;
  return { id: snap.docs[0].id, data: snap.docs[0].data() };
}

export async function acceptAutoFillWithdrawalTerms(uid) {
  const user = await userDocByUid(uid);
  if (!user) throw new Error("User not found");
  const now = new Date().toISOString();
  await updateDoc(doc(db, "users", user.id), {
    autoFillTermsAccepted: true,
    autoFillTermsAcceptedAt: now,
    autoFillTermsVersion: AUTO_FILL_TERMS_VERSION,
    updatedAt: now,
  });
}

export async function saveProgramWalletForWithdrawal(uid, address) {
  const user = await userDocByUid(uid);
  if (!user) throw new Error("User not found");
  const trimmed = (address || "").trim();
  if (!trimmed) throw new Error("Enter a program wallet address");
  const now = new Date().toISOString();
  await updateDoc(doc(db, "users", user.id), {
    [PROGRAM_WALLET_FIELD]: trimmed,
    [PROGRAM_WALLET_VERIFIED_FIELD]: false,
    autoFillProgramWalletSubmittedAt: now,
    updatedAt: now,
  });
}

export async function adminVerifyProgramWalletForWithdrawal(uid, verified = true) {
  const user = await userDocByUid(uid);
  if (!user) throw new Error("User not found");
  const now = new Date().toISOString();
  await updateDoc(doc(db, "users", user.id), {
    [PROGRAM_WALLET_VERIFIED_FIELD]: verified,
    autoFillProgramWalletVerifiedAt: verified ? now : null,
    updatedAt: now,
  });
}

export async function adminVerifyVBoostForWithdrawal(uid, verified = true) {
  const user = await userDocByUid(uid);
  if (!user) throw new Error("User not found");
  const now = new Date().toISOString();
  await updateDoc(doc(db, "users", user.id), {
    autoFillVBoostVerified: verified,
    autoFillVBoostVerifiedAt: verified ? now : null,
    updatedAt: now,
  });
}
